module.exports = __webpack_public_path__ + "img/arcos-c-img-7.cbe2d848.jpg";